import type { Location } from "react-router-dom";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";

import {
  ForgotPassword,
  InvitationExpiredScreen,
  Login,
  NotFoundScreen,
  ResetPassword,
} from "~/providers/screens";
import { SuccessAuthScreen } from "../screens/SuccessAuthScreen";
import { TeamMemberSignUp } from "../screens/TeamMemberSignUp";
import { ROUTES } from "./routes";

export const GuestRouter = () => {
  const location = useLocation();
  const { previousLocation } = (location.state ?? {}) as {
    previousLocation?: Location;
  };

  return (
    <Routes location={previousLocation ?? location}>
      <Route element={<Navigate to={ROUTES.login} replace />} path={"*"} />
      <Route element={<Login />} path={ROUTES.login} />
      <Route element={<ForgotPassword />} path={ROUTES.forgotPassword} />
      <Route element={<ResetPassword />} path={ROUTES.resetPassword} />
      <Route element={<TeamMemberSignUp />} path={ROUTES.signUp} />
      <Route element={<SuccessAuthScreen />} path={ROUTES.successAuth} />
      <Route element={<NotFoundScreen />} path={ROUTES.notFound} />
      <Route
        element={<InvitationExpiredScreen />}
        path={ROUTES.invitationExpired}
      />
    </Routes>
  );
};
